const {Component, createRef} = window.wp.element;
const {__} = window.wp.i18n;
// import FormBuilder from 'react-form-builder2';
import WiFormSettings from './FormSettings';
import WiNewFormBuilder from './FormBuilder';
// import WiFormRender from './FormRender';



class WiFormBuilder extends Component
{

	constructor(props) {
        super(props);
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleBuilderData = this.handleBuilderData.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.state = {
            form_data: {},
            settings: {},
            active_tab: 'builder',
            processing: false
        };
        this.fb = createRef();
    }
    componentDidMount() {
    }
    handleTabClick(e, type) {

        this.setState(() => {
            return {
                active_tab: type
            };
        });
        e.preventDefault();
    }
    handleBuilderData(data) {
        this.setState({
            form_data: data
        })
    }
    handleSave(e) {
        console.log(this.fb.current)
        this.fb.current.handleChange()
        this.setState({
            processing: true
        })
        $('#post').submit();
        //e.preventDefault()
    }
    render() {
        const {active_tab} = this.state;
        let content = ''
        let post_id = document.getElementById('post_ID').value

        if(active_tab == 'builder') {
            content = (<WiNewFormBuilder ref={this.fb} />);
        } else if( active_tab == 'settings' ) {
            content = (<WiFormSettings />);
        }
        return (
        	<div>
        		<div className="wif-forms-tabs">
        			<a href="#" className={(active_tab == 'builder') ? "active" : ''} onClick={(e) => this.handleTabClick(e, 'builder')}>
                        <i className="dashicons dashicons-rest-api"></i>
                        {__('Builder', 'webinane-forms')}
                    </a>
        			<a href="#" className={(active_tab == 'settings') ? 'active' : ''} onClick={(e) => this.handleTabClick(e, 'settings')}>
                        <i className="dashicons dashicons-admin-settings"></i>
                        {__('Settings', 'webinane-forms')}
                    </a>
                    <input type="hidden" name="post_status" value="publish" />
                    <button type="submit" className="button button-primary pull-right" onClick={this.handleSave} disabled={this.state.processing}>{__('Save')}</button>
        		</div>
                <div className="wif-forms-tab-content">
	                {content}
                </div>
	        </div>
            
        );
    }
}

//With tooling set up, uncomment the following two lines to check WP with interactive react
let element = document.querySelector( '#webinane-forms' );
// const WiFormBuilder = WiFormBuilder;


if(element) {
	// let metabox_id = element.getAttribute('data-id');
	//import Counter from './components/Counter';

	wp.element.render(<WiFormBuilder />,  element);

}